

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { BillingProfileSetup } from "../../components/BillingProfileSetup";


export const BillingProfileSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Billing Profile"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Billing Profile", navigateTo: "/billing-profile" }
      ]}
      mainContents={<BillingProfileSetup />}
    />
  );
};
